import React from "react";
import { withStyles } from "@material-ui/styles";
import { IconButton, Typography } from "@material-ui/core";
import closeIcon from "../../assets/icons/submit_bill/close_btn.svg";
import deleteIcon from "../../assets/icons/submit_bill/delete_btn.svg";
import pdfIcon from "../../assets/icons/submit_bill/pdf.svg";

const styles = (theme) => {
  return {
    billatt: {
      display: "flex",
      width: "100%",
      marginBottom: "18px",
      padding: "5px",
      height: "146px",
      backgroundColor: theme.palette.cards.backgroundColor,
      boxShadow: "0px 0px 4px #c3c3c3",
      borderRadius: "4px",
      [theme.breakpoints.down(641)]: {
        height: "131px",
        marginBottom: "16px",
      },
      [theme.breakpoints.down(481)]: {
        height: "98px",
        marginBottom: "12px",
      },
      [theme.breakpoints.down(381)]: {
        height: "74px",
        marginBottom: "10px",
      },
      [theme.breakpoints.down(321)]: {
        height: "66px",
        marginBottom: "8px",
      },
      "& $img_container": {
        width: "25%",
        height: "126px",
        backgroundColor: theme.palette.img.backgroundColor,
        marginRight: "12px",
        overflow: "hidden",

        [theme.breakpoints.down(641)]: {
          height: "113px",
        },
        [theme.breakpoints.down(481)]: {
          height: "85px",
        },
        [theme.breakpoints.down(381)]: {
          height: "64px",
        },
        [theme.breakpoints.down(321)]: {
          height: "57px",
        },
        "& img": {
          width: "100%",
          height: "100%",
          objectFit: "contain",
          objectPosition: "center",
        },
      },
      "& $cnt": {
        width: `calc(75% - ${theme.spacing(3)}px)`,
        display: "flex",
        alignItems: "center",
      },
      "& $content": {
        width: `calc(90% - 10px)`,
        // verticalAlign:
      },
      "& $icon_container": {
        // width: "15%",
        position: "relative",
        "& $iconBtnDel": {
          position: "absolute",
          top: "calc(50% - 30px)",
          [theme.breakpoints.down("sm")]: {
            top: "calc(50% - 26px)",
          },
          [theme.breakpoints.down("xs")]: {
            top: "calc(50% - 22px)",
          },
          "& $deleteIcon": {
            width: "30px",
            height: "30px",
            "--size ": "70px",
            display: "inline-block",
            transition: ".12s",
            "-webkit-mask-size": "cover",
            "mask-size ": "cover",
            [theme.breakpoints.down(641)]: {
              width: "27px",
              height: "27px",
            },
            [theme.breakpoints.down(481)]: {
              width: "21px",
              height: "21px",
            },
            [theme.breakpoints.down(381)]: {
              width: "16px",
              height: "16px",
            },
            [theme.breakpoints.down(321)]: {
              width: "14px",
              height: "14px",
            },
          },
        },
        "& $iconBtnClose": {
          position: "absolute",
          top: "calc(50% - 24px)",
          [theme.breakpoints.down("sm")]: {
            top: "calc(50% - 20px)",
          },
          [theme.breakpoints.down("xs")]: {
            top: "calc(50% - 16px)",
          },
          "& $closeIcon": {
            width: "28px",
            height: "28px",
            "--size ": "70px",
            display: "inline-block",
            transition: ".12s",
            "-webkit-mask-size": "cover",
            "mask-size ": "cover",
            [theme.breakpoints.down(641)]: {
              width: "25px",
              height: "25px",
            },
            [theme.breakpoints.down(481)]: {
              width: "19px",
              height: "19px",
            },
            [theme.breakpoints.down(381)]: {
              width: "14px",
              height: "14px",
            },
            [theme.breakpoints.down(321)]: {
              width: "12px",
              height: "12px",
            },
          },
        },
      },
    },
    progress_container: {
      width: "100%",
      marginTop: theme.spacing(2),
      [theme.breakpoints.down(481)]: {
        marginTop: "6px",
      },
      [theme.breakpoints.down(381)]: {
        marginTop: "3px",
      },
      [theme.breakpoints.down(321)]: {
        marginTop: "2px",
      },
      marginBottom: theme.spacing(2),
      "& $large_progress": {
        width: "100%",
        backgroundColor: theme.palette.progressBar.processing,
        height: "10px",
        borderRadius: "5px",

        [theme.breakpoints.down(481)]: {
          height: "8px",
        },
        [theme.breakpoints.down(381)]: {
          height: "6px",
        },
      },
      "& $range": {
        borderRadius: "5px",
        height: "10px",
        backgroundColor: theme.palette.progressBar.default,
        [theme.breakpoints.down(481)]: {
          height: "8px",
        },
        [theme.breakpoints.down(381)]: {
          height: "6px",
        },
      },
    },
    bill_name: {
      marginTop: theme.spacing(2),
      width: "100%",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      textAlign: "left",
      color: theme.palette.typography.texts.color,
      fontWeight: "500",
      fontSize: "20px",
      [theme.breakpoints.down(641)]: {
        fontSize: "16px",
      },
      [theme.breakpoints.down(481)]: {
        fontSize: "14px",
        marginTop: theme.spacing(1),
      },
      [theme.breakpoints.down(421)]: {
        fontSize: "13.5px",
      },
      [theme.breakpoints.down(401)]: {
        fontSize: "13px",
      },
      [theme.breakpoints.down(381)]: {
        fontSize: "12.5px",
      },
      [theme.breakpoints.down(361)]: {
        fontSize: "12px",
      },
      [theme.breakpoints.down(321)]: {
        fontSize: "10px",
      },
    },
    bill_size: {
      marginTop: "4px",
      textAlign: "left",
      color: "#7e7e7e",
      fontSize: "18px",
      [theme.breakpoints.down(641)]: {
        fontSize: "14px",
      },
      [theme.breakpoints.down(481)]: {
        fontSize: "12px",
      },
      [theme.breakpoints.down(421)]: {
        fontSize: "11.5px",
      },
      [theme.breakpoints.down(401)]: {
        fontSize: "11px",
      },
      [theme.breakpoints.down(381)]: {
        fontSize: "10.5px",
      },
      [theme.breakpoints.down(361)]: {
        fontSize: "10px",
      },
      [theme.breakpoints.down(321)]: {
        fontSize: "8px",
      },
    },
    img_container: {},
    cnt: {},
    content: {},
    icon_container: {},
    iconBtnDel: {},
    iconBtnClose: {},
    deleteIcon: {},
    closeIcon: {},
    large_progress: {},
    range: {},
    icondeleteCss: {
      backgroundColor: "#cecece",
      " -webkit-mask-image": `url(.${deleteIcon})`,
      "mask-image": `url(.${deleteIcon})`,
      mask: `url(.${deleteIcon}) no-repeat center / contain`,
      "-webkit-mask": `url(.${deleteIcon}) no-repeat center / contain`,
    },
    closeIconCss: {
      backgroundColor: "#cecece",
      " -webkit-mask-image": `url(.${closeIcon})`,
      "mask-image": `url(.${closeIcon})`,
      mask: `url(.${closeIcon}) no-repeat center / contain`,
      "-webkit-mask": `url(.${closeIcon}) no-repeat center / contain`,
    },
    pdfIconCss: {
      backgroundColor: theme.palette.primary.main,
      " -webkit-mask-image": `url(.${pdfIcon})`,
      "mask-image": `url(.${pdfIcon})`,
      mask: `url(.${pdfIcon}) no-repeat center / contain`,
      "-webkit-mask": `url(.${pdfIcon}) no-repeat center / contain`,
    },
    pdfCss: {
      display: "inline-block",
      transition: ".12s",
      "-webkit-mask-size": "cover",
      "mask-size ": "cover",
      position: "relative",
      top: "28%",
      height: "55px",
      width: "55px",
      [theme.breakpoints.down(641)]: {
        height: "45px",
        width: "45px",
      },
      [theme.breakpoints.down(481)]: {
        height: "40px",
        width: "40px",
      },
      [theme.breakpoints.down(421)]: {
        height: "35px",
        width: "35px",
      },
      [theme.breakpoints.down(381)]: {
        height: "30px",
        width: "30px",
      },
      [theme.breakpoints.down(361)]: {
        height: "25px",
        width: "25px",
      },
      [theme.breakpoints.down(321)]: {
        height: "20px",
        width: "20px",
      },
    },
  };
};

const MultiClickImage = (props) => {
  const { classes } = props;
  const {
    bill_src,
    bill_name,
    bill_size,
    deleteHandler,
    closeHandler,
    percent,
    id,
    isPdf,
  } = props;
  return (
    <div className={classes.billatt}>
      <div
        className={classes.img_container}
        onClick={(e) => props.onImageClicked(e, bill_src, isPdf)}
      >
        {isPdf ? (
          <a href={bill_src} target="_blank" rel="noopener noreferrer">
            <span className={classes.pdfIconCss + " " + classes.pdfCss} />
          </a>
        ) : (
          <img src={bill_src} alt="bill" />
        )}
      </div>
      <div className={classes.cnt}>
        <div className={classes.content}>
          {percent ? (
            <Typography className={classes.bill_size}>
              Wait, we are still uploading...
            </Typography>
          ) : (
            <Typography className={classes.bill_name}>{bill_name}</Typography>
          )}

          {percent ? (
            <div className={classes.progress_container}>
              <div className={classes.large_progress}>
                <div
                  className={classes.range}
                  style={{ width: `${true ? percent + "%" : "0%"}` }}
                />
              </div>
            </div>
          ) : (
            <Typography className={classes.bill_size}>{`${(
              bill_size /
              (1024 * 1024)
            ).toFixed(2)}MB`}</Typography>
          )}
        </div>
        <div className={classes.icon_container}>
          {percent ? (
            <IconButton
              className={classes.iconBtnClose}
              onClick={() => closeHandler(id)}
            >
              <span
                className={classes.closeIcon + " " + classes.closeIconCss}
                src={closeIcon}
                alt="close"
              />
            </IconButton>
          ) : (
            <IconButton
              className={classes.iconBtnDel}
              onClick={() => deleteHandler(id, bill_size)}
            >
              <span
                className={classes.deleteIcon + " " + classes.icondeleteCss}
              />
            </IconButton>
          )}
        </div>
      </div>
    </div>
  );
};

export default withStyles(styles, { withTheme: true })(MultiClickImage);
